export default __webpack_public_path__ + "static/media/LexendDeca-Black.faa1106c.ttf";